// extracted by mini-css-extract-plugin
export default {"excerptWrapper":"a4PIwFkvkROBxJehoVCp"};